// Copyright Caproc Oy
// System name: Aqua-Net
// System module: Company
// Author: TS
//
// 8.4.2026 TS (claude) Widen desktop layout container (max-width 1600px); removed Grid 'container' prop that was capping width
// 16.4.2026 TS (claude) Added Mailing list menu item for Superuser/Admin users

import React from "react";
import { Grid, Container, Segment, Header, Menu } from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from 'react-i18next';


const Shell = props => (
    <Segment vertical>
        <Container style={{ width: "95%", maxWidth: 1600 }}>
            <Grid stackable verticalAlign="top" divided columns={2}>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Header as="h3">{props.t("Company")}</Header>
                        <Menu vertical fluid>
                            <Menu.Item>
                                <Header as="h4">{props.t("Basic details")}</Header>
                            </Menu.Item>
                            <Menu.Item
                                active={props.location.pathname === "/company/company-details"}
                                onClick={() => props.history.push("/company/company-details")}
                                name="company-details"
                            >
                                {props.t("Details")}
                            </Menu.Item>
                            {/* <Menu.Item
                                active={props.location.pathname === "/company/invoicing-details"}
                                onClick={() => props.history.push("/company/invoicing-details")}
                                name="invoicing-details"
                            >
                                {props.t("Invoicing")}
                            </Menu.Item> 
                            <Menu.Item
                                active={props.location.pathname === "/company/contacts"}
                                onClick={() => props.history.push("/company/contacts")}
                                name="company-contacts"
                            >
                                {props.t("Contacts")}
                            </Menu.Item>*/}
                            {(props.activeRoles && (props.activeRoles.includes("A") || props.activeRoles.includes("S"))) ? (
                                <Menu.Item
                                    active={props.location.pathname === "/company/users"}
                                    onClick={() => props.history.push("/company/users")}
                                    name="company-users"
                                >
                                    {props.t("Users")}
                                </Menu.Item>
                            ) : (
                                <Menu.Item
                                    disabled={true}
                                    active={props.location.pathname === "/company/users"}
                                    onClick={() => props.history.push("/company/users")}
                                    name="company-users"
                                >
                                    {props.t("Users")}
                                </Menu.Item>

                            )}
                            {(props.activeRoles && (props.activeRoles.includes("A") || props.activeRoles.includes("S"))) && (
                                <Menu.Item
                                    active={props.location.pathname === "/company/mailing-list"}
                                    onClick={() => props.history.push("/company/mailing-list")}
                                    name="company-mailing-list"
                                >
                                    {props.t("Mailing list")}
                                </Menu.Item>
                            )}
                              {/*
                            <Menu.Item
                                active={props.location.pathname === "/company/files"}
                                onClick={() => props.history.push("/company/files")}
                                name="company-files"
                            >
                                {props.t("Files")}
                            </Menu.Item>
                            <Menu.Item>
                                <Header as="h4">{props.t("Products")}</Header>
                            </Menu.Item>

                            <Menu.Item
                                active={props.location.pathname === "/product/products"}
                                onClick={() => props.history.push("/product/products")}
                                name="products"
                            >
                                {props.t("Products")}
                            </Menu.Item>
                            <Menu.Item
                                active={props.location.pathname === "/product/product-groups"}
                                onClick={() => props.history.push("/product/product-groups")}
                                name="product-groups"
                            >
                                {props.t("Product Groups")}
                            </Menu.Item>
                            <Menu.Item>
                                <Header as="h4">{props.t("Tasks")}</Header>
                            </Menu.Item> 
                            <Menu.Item
                                active={props.location.pathname === "/company/tasks"}
                                onClick={() => props.history.push("/company/tasks")}
                                name="tasks"
                            >
                                {props.t("Completed tasks")}
                            </Menu.Item>
                            */}
                        </Menu>
                    </Grid.Column>
                    <Grid.Column width={13}>{props.children}</Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </Segment>
);

const mapStateToProps = state => {
    return {
        activeRoles: state.company.activeRoles
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        null
    )(withTranslation('companyshell')(Shell))
);